webpackJsonp([10013748475682],{

/***/ "./src/components/Services.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Services;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ServicesModule = __webpack_require__("./src/components/Services.module.scss");
	
	var _ServicesModule2 = _interopRequireDefault(_ServicesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Services.propTypes = {
	  services: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
	};
	
	function Services(_ref) {
	  var services = _ref.services;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _ServicesModule2.default.root },
	    services.map(function (service) {
	      return _react2.default.createElement(
	        'li',
	        { key: service.id, className: _ServicesModule2.default.item },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _ServicesModule2.default.link, to: '/services/' + service.slug },
	          _react2.default.createElement(
	            'div',
	            { className: _ServicesModule2.default.image },
	            _react2.default.createElement('div', { style: { backgroundImage: 'url(' + service.image.file.url + ')' } })
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: _ServicesModule2.default.title },
	            service.title
	          ),
	          _react2.default.createElement('div', {
	            className: _ServicesModule2.default.description,
	            dangerouslySetInnerHTML: { __html: service.content.childMarkdownRemark.html.match(/^<p>(.+?)<\/p>/)[1] }
	          })
	        )
	      );
	    })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Services.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----Services-module---root---1Y0z0","item":"src-components----Services-module---item---4zvsa","link":"src-components----Services-module---link---2wmXe","image":"src-components----Services-module---image---MpVj-","title":"src-components----Services-module---title---2rZFt","description":"src-components----Services-module---description---1fUFK"};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/Homepage.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = HomepageTemplate;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentful = __webpack_require__("./src/utils/contentful.js");
	
	var _Page = __webpack_require__("./src/components/Page.js");
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Services = __webpack_require__("./src/components/Services.js");
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _HomepageModule = __webpack_require__("./src/templates/Homepage.module.scss");
	
	var _HomepageModule2 = _interopRequireDefault(_HomepageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	HomepageTemplate.propTypes = {
	  data: _propTypes2.default.shape({
	    page: _propTypes2.default.shape({
	      title: _propTypes2.default.string.isRequired,
	      content: _propTypes2.default.shape({
	        childMarkdownRemark: _propTypes2.default.shape({
	          html: _propTypes2.default.string
	        }).isRequired
	      }).isRequired,
	      image: _propTypes2.default.shape({
	        file: _propTypes2.default.shape({
	          url: _propTypes2.default.string.isRequired
	        }).isRequired
	      })
	    }).isRequired,
	    pages: _propTypes2.default.shape({}).isRequired,
	    servicesPage: _propTypes2.default.shape({}).isRequired
	  }).isRequired,
	  location: _propTypes2.default.shape({}).isRequired
	};
	
	function HomepageTemplate(_ref) {
	  var _ref$data = _ref.data,
	      _ref$data$page = _ref$data.page,
	      title = _ref$data$page.title,
	      content = _ref$data$page.content,
	      image = _ref$data$page.image,
	      pages = _ref$data.pages,
	      servicesPage = _ref$data.servicesPage,
	      location = _ref.location;
	
	  pages = (0, _contentful.getNodes)(pages);
	  var services = servicesPage.subpages;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: title,
	      imageUrl: image && image.file.url,
	      pages: pages,
	      location: location
	    },
	    _react2.default.createElement('article', { dangerouslySetInnerHTML: { __html: content.childMarkdownRemark.html } }),
	    _react2.default.createElement(
	      'div',
	      { className: _HomepageModule2.default.services },
	      _react2.default.createElement(_Services2.default, { services: services })
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ "./src/templates/Homepage.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"locations":"src-templates----Homepage-module---locations---2z23s","services":"src-templates----Homepage-module---services---3XCnU"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-homepage-js-41fe75fdd9118b3e53fe.js